module.exports = __webpack_public_path__ + "static/img/Boy-3.2af80c73.png";